export function normalizeGender(gender: string): string {
  if (!gender) return 'U';
  const g = gender.toUpperCase();
  if (g === 'M' || g === 'MALE') return 'M';
  if (g === 'F' || g === 'FEMALE') return 'F';
  return 'U';
}
